import {
    ActionType,
    GET_PANEL_SUCCEEDED,
    GET_PANEL_FAILED,
    LIST_PANEL_SUCCEEDED,
    LIST_PANEL_FAILED,
    PanelType,
    ErrorType,
    SET_CURRENT_ACTIVITY_SUCCEEDED,
    SET_CURRENT_ACTIVITY_FAILED,
    PANELS_KEY,
    RESET_HARMONIZE_TIME,
} from './types';
import { getItem, setItem } from '../../utils/localStorage';

const storedPanels = getItem(PANELS_KEY);
const initialState: {
    data: PanelType[];
    error: ErrorType;
    activity: PanelType | null;
    affirmations: string[];
    backgroundAudioFileName: string;
    text: string;
    harmonizeTime: 1800000,
} = {
    ...storedPanels,
    affirmations: [
        'I Am Divine Love',
        'I Am Divine Light',
        'I Am Divine Health',
        'I Am Divine Peace',
        'I Am Divine Truth',
        'I Easily Manifest Divine Abundance For Myself And Others',
        'The Water I Drink Is Harmonized Perfectly For My Body',
        'I Live In Infinite Love & Gratitude',
        'I Am Divine Joy',
    ],
    backgroundAudioFileName: 'WH_BackingTrack.mp3',
    text: `The Water Harmonizer is a revolutionary wellness app, using the Quantum Field to communicate with your innate intelligence to determine what is required for the body to restore and maintain perfect balance, using Quantum Harmonics.  Most health issues are caused by out-of-balance emotions and poor nutrition.  The Water Harmonizer creates a field of conductivity, which utilizes your intention to consciously charge the water.Water is so important. Not only does it keep you alive, it keeps you connected. You are a bit like a battery, you need water to be able to connect to higher states of consciousness. You need water to be able to connect to others. You need water to connect to other parts of yourself! It is so very important to stay hydrated. Water will help the information flow. The water will help the actual connection to information.  Water maintains memory and by utilizing this ability, we can infuse life sustaining nutrients into the body using the imprinted energetic signatures of the nutrients.  There are currently 11 unique custom panels integrated into the Water Harmonizer, each one having a distinct message for the body and collectively harmonizing any imbalances.These 11 custom panels have been tried and tested with immense success on humans, animals and plant life.  Combined with the profound effect of positive intentions and emotions, in the form of affirmations, these imprintedsignatures in water create harmony and transformation.  The Water Harmonizer restructures water and uses information specifically designed to aid the body and support overall wellbeing.The body is on average 70% water.   This is why we have chosen restructured water to be the perfect conduit for providing the body with the information it needs to achieve optimum wellbeing.Most people feel the benefits within minutes of using the Water Harmonizer. It is very easy to use and share with others!When you join our Quantum family, you become a member of our unique group of forward thinking individuals, who are using cutting edge Quantum technology to support our basic needs; sleep, energy, digestion, his and hershormones/emotions, discomfort, vision, memory/focus, general detox, inflammation.Discomfort:Using Quantum information to help the body achieve physical relief.  
Energy:Using Quantum information to provide optimum performance.Vision:People have reported improved visual acuity using this technology.Memory/Focus:Provides for increased cognitive awareness.General Detox:Helping the body to process and remove unwanted toxins.Inflammation:Using this Quantum technology to reduce inflammatory response.Digestion:Helps provide for a smooth absorption of nutrients while eliminating toxins out of the body.Sleep:Helps to promote a deeper level of relaxation and sleep and restoration.Hormones/Emotions (Hers):Correcting both hormonal and emotional imbalances.  Hormones/Emotions (His):Correcting both hormonal and emotional imbalances.  Wellness Charge:Super charge your body with optimal nutrition.`,
};

export default function reducer(state = initialState, action: ActionType) {
    // console.log('reducer panels: ', action);
    let localPanels;
    let localState;
    switch (action.type) {
        case GET_PANEL_SUCCEEDED:
            if (!action.payload?.panel)
                localState = {
                    ...state,
                };
            localPanels = state.data.filter((p) => p.id !== action?.payload?.panel?.id) || [];
            localState = {
                ...state,
                data: [...localPanels, action.payload.panel],
            };
            break;
        case GET_PANEL_FAILED:
            return {
                ...state,
                error: action.payload,
            };
        case LIST_PANEL_SUCCEEDED:
            localState = {
                ...state,
                data: action.payload?.panels,
                error: {},
            };
            break;
        case LIST_PANEL_FAILED:
            localState = {
                ...state,
                data: [],
                error: action.payload.error,
            };
            break;
        case SET_CURRENT_ACTIVITY_SUCCEEDED:
            localState = {
                ...state,
                activity: action.payload,
            };
            break;
        case SET_CURRENT_ACTIVITY_FAILED:
            localState = {
                ...state,
                error: action.payload,
            };
            break;
        case RESET_HARMONIZE_TIME:
            localState = {
                ...state,
                harmonizeTime: initialState.harmonizeTime,
        };
            break;
            default:
            localState = state;
    }

    // console.log(localState);
    setItem(PANELS_KEY, localState);
    return localState;
}
